import {Component, DestroyRef, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {
  CurrentCrudSelectBehaviorServiceAsString,
  SnackBarService
} from '../objectPassingService';
import {AdService} from '../ads/ads_service';
import {Subject, takeUntil} from 'rxjs';
import {MatButton, MatButtonModule} from '@angular/material/button';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {CreateAdPayloadModel, GetAllAdPayloadModel} from '../ads/ad_interfaces';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput, MatInputModule} from '@angular/material/input';

import {MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import {CreateAdInitPayload} from '../ads/ads.component';
import {environment} from '../../environments/environment';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {MatCheckbox} from '@angular/material/checkbox';
import {HttpClient} from '@angular/common/http';
import { HttpEvent, HttpEventType } from '@angular/common/http';

// function isCreateAdInitPayload(obj: any): obj is CreateAdInitPayload {
//   return obj && typeof obj === 'object' && 'is_edit' in obj && typeof obj.is_edit === 'boolean';
// }

function isCreateAdInitPayload(obj: any): obj is CreateAdInitPayload {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.is_edit === false &&
    Object.keys(obj).length === 1
  );
}

function isGetAllAdPayloadModel(obj: any): obj is GetAllAdPayloadModel {
  /*
  The reason we kept both isCreateAdInitPayload() and isGetAllAdPayloadModel() was:
	•	To future-proof (in case is_edit accidentally shows up in GetAllAdPayloadModel)
	•	To keep the checks isolated and testable
	•	To avoid assumptions in the “else” branch
   */
  return obj && typeof obj === 'object' && typeof obj.name === 'string';
}

@Component({
  selector: 'app-ads-meta',
  imports: [
    MatButton,
    FormsModule,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatCardModule,
    MatToolbarModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatDividerModule,
    MatListModule,
    MatSlideToggle,
    MatCheckbox
  ],
  templateUrl: './ads-meta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ads-meta.component.css'
})
export class AdsMetaComponent implements OnInit, OnDestroy {

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_edit = false;
  is_form_error: boolean = false;
  form_error_message: string = "";
  myForm!: FormGroup;
  title_text = "Create Ad";
  submit_text = "Create"


  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  campaign_id: string = '';
  adgroup_id: string = '';
  adgroup_type: string = '';
  ad_id: string = '';
  is_loading = true;

  selectedFileName: string | null = null;


  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    public router: Router, //all components need this
    private currentCrudSelectBehaviorService: CurrentCrudSelectBehaviorServiceAsString,
    private adService: AdService,
    private http: HttpClient
  ) { } // constructor

  ngOnInit(): void {
    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_sequence_id = localStorage.getItem('campaign_group_sequence_id') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';
    this.adgroup_id = localStorage.getItem('adgroup_id') || '';
    this.ad_id = localStorage.getItem('ad_id') || '';
    this.adgroup_type = localStorage.getItem('adgroup_type') || '';
    console.log(this.adgroup_type);

    // Use localStorage data on reload
    const savedAdMeta = localStorage.getItem('adsaved');
    if (savedAdMeta) {
      // now if I want I can ... if exists go back to ads rather than having
      // to deal with updating saved storage e.g. on input update saved storage
      // will keep on for development for now
      //this.backToAds()

      if (environment.environment == 'production') {
        this.backToAds()
      }

      try {
        const parsed = JSON.parse(savedAdMeta);
        if (isCreateAdInitPayload(parsed)) {
          const obj: CreateAdInitPayload = parsed;
          console.log('[Reload] Editing state:', obj);
          this.setForm(); // Or pass in data if needed
          this.is_edit = obj.is_edit;
        } else if (isGetAllAdPayloadModel(parsed)) {
          const obj: GetAllAdPayloadModel = parsed;
          console.log('[Reload ] Ad Data:', obj);
          this.setForm(obj);
          this.is_edit = true;
          this.ad_id = obj.ad_id;
        }
      } catch (e) {
        console.error('Error parsing localStorage adsaved:', e);
      }
    } // end if savedAdMeta

    // Subscriptions from services (live interaction)
    this.currentCrudSelectBehaviorService.current$.pipe(takeUntil(this.destroyed)).subscribe(x => {
      if (!x) return;

      try {
        const parsed = JSON.parse(x);

        if (isCreateAdInitPayload(parsed)) {
          console.log('[Stream] Create Payload:', parsed);
          this.setForm();
          this.is_edit = parsed.is_edit;
        } else if (isGetAllAdPayloadModel(parsed)) {
          console.log('[Stream] Edit Payload:', parsed);
          this.setForm(parsed);
          this.is_edit = true;
        } else {
          throw new Error('Unknown payload structure');
        }

        localStorage.setItem('adsaved', JSON.stringify(parsed));
      } catch (e) {
        console.error('Error parsing stream payload:', e);
      }
    }); // end subscription

  } // end ngOnInit

  data_edit?: GetAllAdPayloadModel
  image_url: string | null | undefined
  setForm(data?: GetAllAdPayloadModel) {

    if (!data) {

      this.myForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        status: new FormControl(false),
        sms_text: new FormControl('', []),
        redirect_url: new FormControl('', []),
        is_dummy_ad: new FormControl(false),
      });

    } else {
      this.submit_text = "Edit"

      console.log('WOWWWWWWWW',data)
      this.data_edit = data

      this.image_url = data.image_meta?.image_url || null;
      console.log(this.image_url);

      let is_status =false;
      if (data.status == "active") {
        is_status = true;
      } else {
        is_status = false;
      }


      this.myForm = this.fb.group({
        name: [data.name],
        sms_text: [data.sms_text],
        redirect_url: [data.redirect_url],
        status: [is_status],
        is_dummy_ad: [data.is_dummy_ad ?? false]
      });
    }

    this.is_loading = false
  } // setForm

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } // ngOnDestroy

  backToAds() {
    localStorage.removeItem('adsaved')
    //this.router.navigate(['/nav-campaigns', {outlets: {admeta: ['ads']}}]);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['ads'] } }]).then(r => console.log('redirect to ads'));
  } // end backToAds

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = "";
  }

  onDummyAdChange(){

    if (this.myForm.value['is_dummy_ad'] == true) {
      this.myForm.get('sms_text')?.setValue("DUMMY_AD");
    }
    if (this.myForm.value['is_dummy_ad'] == false) {
      this.myForm.get('sms_text')?.setValue("");
    }

  }

  previewUrl: string | null = null;
  selectedFile: File | null = null;
  onPngSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
    this.selectedFileName = file.name;
    console.log('Selected file name:', this.selectedFileName);

    // validate type
    const validTypes = ['image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      this.snackBarService.announceSackBar('Only PNG or GIF allowed');
      return;
    }

    // store name
    this.selectedFileName = file.name;

    // preview
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result as string;


    };
    reader.readAsDataURL(file);
  }


  onSubmitMedia(psurl: string, ad_id: string) {
    if (!this.selectedFile) {
      this.snackBarService.announceSackBar('No file selected');
      console.error('[Upload] No file selected');
      return;
    }

    const contentType = this.selectedFile.type?.trim() || null;
    const originalName = this.selectedFile.name;
    const extension = originalName.split('.').pop()?.toLowerCase() || 'bin';
    const renamedFile = new File([this.selectedFile], `${ad_id}.${extension}`, {
      type: this.selectedFile.type
    });

    console.log('==================== S3 UPLOAD START ====================');
    console.log('[Upload] URL:', psurl);
    console.log('[Upload] Original file name:', originalName);
    console.log('[Upload] Renamed file name:', renamedFile.name);
    console.log('[Upload] File type (used in header):', contentType || '(none)');
    console.log('[Upload] File size:', renamedFile.size, 'bytes');

    const options = {
      reportProgress: true,
      observe: 'events' as const,
      responseType: 'text' as 'json'
    };

    // Include Content-Type only if backend signs with it
    if (contentType) (options as any).headers = { 'Content-Type': contentType };

    this.http.put(psurl, renamedFile, options).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            console.log('[Upload] Request sent to S3');
            break;

          case HttpEventType.UploadProgress:
            if (event.total) {
              const percent = Math.round((event.loaded / event.total) * 100);
              console.log(`[Upload] Progress: ${percent}%`);
            }
            break;

          case HttpEventType.Response:
            console.log('[Upload] ✅ Upload completed successfully');
            console.log('[Upload] S3 response:', event);
            this.snackBarService.announceSackBar('Upload complete');
            break;
        }
      },
      error: (err) => {
        console.error('==================== S3 UPLOAD ERROR ====================');
        console.error('[Upload] Upload failed');
        console.error('[Upload] URL:', psurl);
        console.error('[Upload] File name sent:', renamedFile.name);
        console.error('[Upload] File type sent:', contentType || '(none)');
        console.error('[Upload] Error:', err);

        if (err?.error?.text?.includes('SignatureDoesNotMatch')) {
          console.error(
            '[Hint] Signature mismatch — ensure backend presigned URL used same file name and Content-Type:',
            renamedFile.name,
            contentType
          );
        }

        this.snackBarService.announceSackBar('Upload failed. Check console.');
      }
    });
  }


  onSubmit(){

    this.is_loading = true;
    let form_data = this.myForm.value;
    form_data['client_id'] =  this.client_id  //Math.floor(parseInt(form_data['client_id'], 10));

    let status = 'paused';
    if (form_data['status'] == true) {
      status = 'active';
    } else {
      status = 'paused';
    }
    form_data['status'] = status;

    // if (form_data['is_dummy_ad'] == true) {
    //   form_data['sms_text'] = "DUMMY_AD";
    // }


    console.log(form_data)


    if (this.adgroup_type.startsWith('image_')) {

      form_data['image_meta'] = {}
      form_data['image_meta']['image_name'] = this.selectedFileName;
      const sizePart = this.adgroup_type.split('_')[1]; // "300x250"   Image_300x250   Width: 300px, Height: 250px

      const [widthStr, heightStr] = sizePart.toLowerCase().split('x'); // split on lowercase x
      console.log(widthStr, heightStr, sizePart)
      const width = parseInt(widthStr, 10);
      const height = parseInt(heightStr, 10);
      form_data['image_meta']['image_width'] = isNaN(width) ? null : width;
      form_data['image_meta']['image_height'] = isNaN(height) ? null : height;
      // Extract format from file name (e.g., "banner.gif" → "gif")
      const fileExtension = this.selectedFileName?.split('.').pop()?.toLowerCase() || null;
      form_data['image_meta']['image_format'] = fileExtension;
    }

    if (!this.is_edit) {

      this.adService.post(`adserver/ad/create/${this.client_id}/${this.campaign_group_sequence_id}/${this.campaign_group_id}/${this.campaign_id}/${this.adgroup_id}`, form_data).pipe(takeUntil(this.destroyed)).subscribe(x => {

        if (this.adgroup_type.startsWith('image_')) {
          let psurl =  x['body']['psurl']
          let ad_id = x['body']['ad_id']
          this.onSubmitMedia(psurl, ad_id)
        }

        this.snackBarService.announceSackBar('Ad Created');
        this.is_loading = false;
        this.backToAds();
      }, error => {
        console.log('error',error)

      });

    } else {

      const ad_id = this.data_edit?.ad_id

      form_data['image_meta']['image_width'] = this.data_edit?.image_meta?.image_width
      form_data['image_meta']['image_height'] = this.data_edit?.image_meta?.image_height
      form_data['image_meta']['image_name'] = this.data_edit?.image_meta?.image_name
      form_data['image_meta']['image_format'] = this.data_edit?.image_meta?.image_format
      form_data['image_meta']['image_url'] = this.data_edit?.image_meta?.image_url

      console.log('we are editing')
      let endpoint = `adserver/ad/${ad_id}`;
      this.adService.put(endpoint, form_data).subscribe(x => {
        this.snackBarService.announceSackBar('Ad Updated');
        this.is_loading = false;
      }, error => {
        this.is_loading = false;
        this.snackBarService.announceSackBar('Ad Update Error');
        console.log('error',error)
      });

    } //end if

  } // end OnSubmit




} // AdsMetaComponent
